import PropTypes from 'prop-types';

import { PM_TEMPLATES, pmPdfTemplate } from '../../constants/pmTemplates';
import EditorIcon from '../editor/EditorIcon';

import CustomDesignCta from './CustomDesignCta';
import LetterThumbnail from './LetterThumbnail';

const DIFFICULTY = {
	simple: { label: 'Schlichter Brief', time: '5 Min.' },
	sidebar: { label: 'Mit Seitenleiste', time: '10 Min.' },
	coloredSidebar: { label: 'Farbige Seitenleiste', time: '15 Min.' },
};

/**
 * Starter-template gallery: the user picks a ready-made template or uploads their own PDF, and the app
 * creates a new user template in the DB from it.
 */
export default function TemplatePicker({ onPick }) {
	return (
		<section className="pm-picker__section">
			<div className="pm-picker__grid">
				{PM_TEMPLATES.map((tpl) => {
					const meta = DIFFICULTY[tpl.layout];
					return (
						<button
							type="button"
							key={tpl.id}
							className={`pm-picker__card pm-picker__card-${tpl.layout}`}
							onClick={() => onPick(tpl)}
						>
							<div className="pm-picker__preview">
								<LetterThumbnail tpl={tpl} />
							</div>
							<div className="pm-picker__body">
								<div className="pm-picker__meta">
									<span className={`pm-picker__difficulty pm-picker__diff-${tpl.layout}`}>
										{meta.label}
									</span>
									<span className="text-muted text-xs">{meta.time}</span>
								</div>
								<div className="pm-picker__name">{tpl.name}</div>
								<div className="pm-picker__desc">{tpl.desc}</div>
								<div className="pm-picker__action">
									<EditorIcon name="plus" size={13} /> Vorlage auswählen
								</div>
							</div>
						</button>
					);
				})}

				<button
					type="button"
					className="pm-picker__card pm-picker__card-blank"
					onClick={() => onPick(pmPdfTemplate())}
				>
					<div className="pm-picker__blank-icon">
						<EditorIcon name="upload" size={28} />
					</div>
					<div className="pm-picker__body">
						<div className="pm-picker__name">Eigenes PDF hochladen</div>
						<div className="pm-picker__desc">
							Fertiges Brief-Design als PDF verwenden. A4 versenden wir automatisch; Sonderformate prüfen
							wir und erstellen ein individuelles Angebot.
						</div>
					</div>
				</button>
			</div>

			<CustomDesignCta />

			<div className="pm-guide__note">
				<EditorIcon name="info" size={14} />
				<div>
					<strong>Druck-Vorgaben sind eingebaut.</strong> Alle Vorlagen halten die PIN eBrief Abstandsvorlage
					für DIN-A4 ein: Adressfenster bei 20/45 mm, Sicherheitsränder oben/unten und Falzmarken. Im Editor
					zeigen wir Ihnen die Zonen — und warnen, wenn Inhalt rausragt.
				</div>
			</div>
		</section>
	);
}

TemplatePicker.propTypes = {
	onPick: PropTypes.func.isRequired,
};
